import type { FaireProductEntity } from "../../entity_types/product";

export const p_rdvm8n2xr6: FaireProductEntity = {
  token: "p_rdvm8n2xr6",
  type: "product",
  name: "Thank You Mushrooms and Flowers",
  brandToken: "b_3a5ba274",
  brandName: "Lucky Horse Press",
  imageUrl:
    "https://cdn.faire.com/fastly/d0add17b52a38cd405449d300fd52939187c9aa1dc6373ec966a7a2130fe658b.jpeg",
  galleryImageUrls: [],
  priceDollars: 3,
  description:
    'Letterpress printed by Lucky Horse Press\n\n• 100 lb. recycled cover\n• 4.25" × 5.5" folded card\n• Blank inside\n• Matching envelopes',
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:55:00.092Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
